module.exports = __webpack_public_path__ + "img/outdoor-humidity.8dcff617.png";